import request from '@/utils/request'
import { encryptPassword } from '@/utils/passwordEncrypt'

export function getCaptcha() {
  return request({
    url: '/yss/admin/captcha/image',
    method: 'get'
  })
}

export function login(username, password, captchaId, captchaCode) {
  return request({
    url: '/yss/admin/login',
    method: 'post',
    data: {
      username,
      password: encryptPassword(password),
      captchaId,
      captchaCode
    }
  })
}

export function getInfo() {
  return request({
    url: '/yss/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/yss/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/yss/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/yss/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: 'yss/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: 'yss/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: 'yss/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: 'yss/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: 'yss/admin/role/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js